import { registerPlugin } from '@capacitor/core';
const GeoLocation = registerPlugin('GeoLocation', {});
export * from './definitions';
export { GeoLocation };
//# sourceMappingURL=index.js.map